import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import HttpService from '../../service/HttpService';
import Header from '../../component/Header';

export default class Smtp extends React.Component {
  http = new HttpService();
  loader = null;
  lo = require( 'lodash' );
  toPost = {};
  
  constructor( props ) {
    super( props );

    this.state = {
      smtp: {}
    };
  }

  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando configuración SMTP...' );
    
    this.http
      .getSMTP()
      .then( smtp => {
        this.setState({ smtp: smtp });

        loader.finish();
      })
      .catch( this.errorHandler );
  }

  errorHandler = ( error ) => {
    this.refs.header.dialog().show( error );
  }

  updateItem = ( item ) => {
    let {smtp} = this.state;
    
    smtp[item.target.name] = item.target.value;

    this.setState({ smtp: smtp });
  }

  saveItemHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .saveSMTP( this.state.smtp )
      .then( ( smtp ) => {
        this.setState({ smtp: smtp });
        
        loader.finish();
      })
      .catch( this.errorHandler );

    this.setState({ showPanel: false });
  }

  render() {
    const menuItems = [
      {
        text: 'Guardar',
        iconProps: {
          iconName: 'Save'
        },
        onClick: this.saveItemHandler
      }
    ];
    const menuFarItems = [
      {
        iconProps: {
          iconName: 'Info'
        }
      }
    ];
    const customItems = [];

    return (
      <Fabric>
        <Header title="Clientes" ref="header" visible={false}/>

        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <CommandBar
                  items={ menuItems }
                  overflowItems={ customItems }
                  farItems={ menuFarItems }
                />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="host" label="Host" value={ this.state.smtp.host } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="port" label="Port" value={ this.state.smtp.port } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="security" label="Security" value={ this.state.smtp.security } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="username" label="Username" value={ this.state.smtp.username } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="password" label="Password" value={ this.state.smtp.password } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="sender_name" label="Enviar como (nombre)" value={ this.state.smtp.sender_name } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="sender_email" label="Enviar coo (email)" value={ this.state.smtp.sender_email } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="to" label="Destinatario" value={ this.state.smtp.to } onChange={ this.updateItem }/>
            </div>
          </div>
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/settings/Smtp.jsx